import React, { useEffect, useState } from "react";
import "./sidebar.scss";
import {
  RiCheckboxCircleLine,
  RiStoreLine,
  RiErrorWarningLine,
} from "react-icons/ri";
import { MdOutlineDashboard } from "react-icons/md";
import { HiOutlineRectangleStack } from "react-icons/hi2";
import { FiBox } from "react-icons/fi";
import { GoTools } from "react-icons/go";
import { VscPackage } from "react-icons/vsc";
import { NavLink } from "react-router-dom";
import { PiChartPieSlice } from "react-icons/pi";
import { RiDiscountPercentLine } from "react-icons/ri";
import { TbTruckReturn } from "react-icons/tb";
import { RiCoupon2Line } from "react-icons/ri";
import { FiLock } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom";

import Logo from "../../../src/assets/images/logo.png";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";

const getLinks = (isAccountVerified) => {
  const isRestricted =
    localStorage.getItem("uid") === "products.alisuq@gmail.com";
  return [
    ...(!isAccountVerified
      ? [
          {
            title: "Onboarding",
            href: "/vendor/onboarding",
            icon: <RiCheckboxCircleLine size="1.4em" />,
          },
        ]
      : []),

    {
      title: "Dashboard",
      href: "/vendor",
      icon: <MdOutlineDashboard size="1.4em" />,
      exact: true,
    },
    {
      title: "Products",
      href: "/vendor/product-catalog",
      icon: <FiBox size="1.4em" />,
    },
    // {
    //   title: "Banners",
    //   href: "/vendor/banners",
    //   icon: <HiOutlineRectangleStack size="1.4em" />,
    // },
    // {
    //   title: "Store & Users",
    //   href: "/vendor/profile",
    //   icon: <RiStoreLine size="1.4em" />,
    // },

    ...(!isRestricted
      ? [
          {
            title: "Services",
            href: "/vendor/service-catalog",
            icon: <GoTools size="1.4em" />,
          },
          {
            title: "Orders",
            href: "/vendor/orders",
            icon: <VscPackage size="1.4em" />,
          },
          {
            title: "Coupons",
            href: "/vendor/coupons",
            icon: <RiCoupon2Line size="1.4em" />,
          },
          {
            title: "Returns",
            href: "/vendor/returns",
            icon: <TbTruckReturn size="1.4em" />,
          },
          {
            title: "Disputes",
            href: "/vendor/disputes",
            icon: <RiErrorWarningLine size="1.4em" />,
          },
          {
            title: "Reports",
            href: "/vendor/reports",
            icon: <PiChartPieSlice size="1.4em" />,
          },
        ]
      : []),
  ];
};

const Sidebar = (props) => {
  /** Status */
  const [vendorDetails, setVendorDetails] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [links, setLinks] = useState(getLinks(true));

  const history = useHistory();

  /** Get the current vendor details */
  useEffect(() => {
    const fetchVendor = async () => {
      try {
        const response = await apiJson.vendorProfile.getVendor();
        setVendorDetails(response.data);
        if (!response?.data?.store?.active) {
          setLinks(getLinks(false));
          setIsDisabled(true);
          history.push("/vendor/onboarding");
        }
      } catch (error) {
        toast.error(
          error.message || "Something went wrong while fetching vendor details",
        );
      }
    };
    fetchVendor();
  }, []);

  return (
    <div className="sidebar">
      <img src={Logo} alt="Logo" className="logo" />

      <div className="container">
        {links.map((item, index) => {
          return (
            <NavLink
              key={index}
              to={item.href}
              exact={item.exact}
              className={`link ${isDisabled && item.title !== "Onboarding" ? "link--disabled" : ""}`}
              activeClassName="link--active"
              onClick={(e) =>
                isDisabled && item.title !== "Onboarding" && e.preventDefault()
              }
            >
              {item.icon}
              <span className="link-title">{item.title}</span>
              {isDisabled && item.title !== "Onboarding" && (
                <span className="link-lock">
                  <FiLock />
                </span>
              )}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
